import { useState, useEffect } from 'react'
import { TextField, MenuItem } from '@material-ui/core'

export const WhatsAppTemplateSelector = (props) => {
  const [templates, setTemplates] = useState([])

  // const fetchTemplates = async () => {
  //   const response = await getTemplates({ organizationId: props.organizationId })
  //   console.log('templates', response)
  //   // filter by event type
  //   setTemplates(response.data.templates.filter(e => e.action === props.eventType))
  //   setIsLoading(false)
  // }

  let required = true

  if (props.hasOwnProperty('required')) {
    required = props.required
  }

  const onChange = (e) => {
    console.log('WhatsAppTemplateSelector.onChange', e.target.value)
    props.onSelect(e.target.value, props.templates.find(t => t.id === e.target.value))
  }

  useEffect(() => {
    // load in the templates
    // if passed in set the selected template
    // call on select
    // fetchTemplates()
    console.log('WhatsAppTemplateSelector.templates', props.templates, props.eventType)
    setTemplates(props.templates.filter(e => e.action === props.eventType))
  }, [props.templates, props.eventType])

  return (
    <TextField
      select
      label={props.label || "WhatsApp Template"}
      margin="dense"
      value={props.templateId}
      onChange={onChange}
      helperText="Select the template you would like to use for this event"
      disabled={props.disabled}
      required={required}
      fullWidth
    >
      {
        !templates.length ? (
          <MenuItem disabled>
            None available
          </MenuItem>
        ) : null
      }
      {
        templates
          // .filter(e => (props.replies || []).filter(r => r.event === e.value && e.value !== state.event).length === 0)
          .map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))
      }
      {
        props.templates.length === 0 && <MenuItem value={0}>No templates found for the event "{props.eventType}"</MenuItem>
      }
    </TextField>
  )
}